var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-input", class: _vm.computedClass },
    [
      _c("div", { staticClass: "input-render" }, [
        _vm.label !== ""
          ? _c("label", { staticClass: "component-label" }, [
              _vm._v(_vm._s(_vm.label))
            ])
          : _vm._e(),
        _c("input", {
          ref: "input",
          staticClass: "component-inner-input w-normal",
          attrs: {
            type: _vm.type,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            autocomplete: "new-password",
            maxlength: _vm.maxlength
          },
          domProps: { value: _vm.value },
          on: {
            focus: _vm.handleInputFocused,
            blur: _vm.handleInputBlur,
            mouseover: _vm.handleInputMouseOver,
            mouseout: _vm.handleInputMouseOut,
            input: _vm.handleInputChange,
            keyup: _vm.handleKeyUp
          }
        })
      ]),
      _vm.showMsg && _vm.msg && _vm.msg !== ""
        ? _c("p", { staticClass: "component-message w-bold" }, [
            _vm._v(_vm._s(_vm.msg))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }